//regieter page 1
import {
  Button,
  VStack,
  Card,
  Input,
  Box,
  CardHeader,
  CardBody,
} from "@chakra-ui/react";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { registerAction } from "../Store/index";
import axios from "axios";
import { BASE_URL } from "../../../constants/defaultValues";

const LoginForm1 = ({ nextStep }) => {
  const registerData = useSelector((state) => state.register);
  const dispatch = useDispatch();
  const handleSubmit = async (values) => {
    //await axios.post(`${BASE_URL}/api/auth/storeMarketingEmail`, {
    // email: values?.email,
    //});
    dispatch(registerAction.form1(values));
    nextStep();
  };

  return (
    // <Box>
      <Card p="15px" mx="auto" w={{ base: "90%", md: "70%", lg: "60%" }}>
        <CardHeader color="#2A3042" fontSize="24px" fontWeight="semibold">
          Start your free trial
        </CardHeader>

        <CardBody>
          <Formik
            initialValues={{
              firstname: registerData.firstname,
              lastname: registerData.lastname,
              email: registerData.email,
              password: registerData.password,
              confirmPassword: registerData.password,
            }}
            validate={(values) => {
              const errors = {};

              if (!values.firstname) {
                errors.firstname = "First name is required.";
              }
              if (!values.lastname) {
                errors.lastname = "Last name is required.";
              }
              if (!values.email) {
                errors.email = "Email is required.";
              } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              ) {
                errors.email = "Invalid email address";
              }
              if (!values.password) {
                errors.password = "Password is required.";
              } else if (values.password.length < 6) {
                errors.password = "Password must be greater than 6 character";
              }
              if (!values.confirmPassword) {
                errors.confirmPassword = "Confirm password is required.";
              } else if (values.password !== values.confirmPassword) {
                errors.confirmPassword = "Confirm password not match";
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              // setSubmitting(false);
              handleSubmit(values);
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
            }) => (
              <form
                onSubmit={handleSubmit}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div>
                  <label htmlFor="fullname">
                    First Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <Input
                    type="text"
                    id="firstname"
                    name="firstname"
                    onChange={handleChange}
                    value={values.firstname}
                    borderColor="gray"
                    onBlur={handleBlur}
                    borderWidth="1px"
                  />
                  <div style={{ color: "red" }}>
                    {errors.firstname && touched.firstname && errors.firstname}
                  </div>
                </div>
                <div>
                  <label htmlFor="lastname">
                    Last Name <span style={{ color: "red" }}>*</span>
                  </label>
                  <Input
                    type="text"
                    id="lastname"
                    name="lastname"
                    onChange={handleChange}
                    value={
                      values.lastname ? values.lastname : registerData.lastname
                    }
                    borderColor="gray"
                    onBlur={handleBlur}
                    borderWidth="1px"
                  />
                  <div style={{ color: "red" }}>
                    {errors.lastname && touched.lastname && errors.lastname}
                  </div>
                </div>

                <div>
                  <label htmlFor="email">
                    Email <span style={{ color: "red" }}>*</span>
                  </label>
                  <Input
                    type="email"
                    id="email"
                    name="email"
                    onChange={handleChange}
                    value={values.email}
                    borderColor="gray"
                    onBlur={handleBlur}
                    borderWidth="1px"
                  />
                  <div style={{ color: "red" }}>
                    {errors.email && touched.email && errors.email}
                  </div>
                </div>

                <div>
                  <label htmlFor="password">
                    Password <span style={{ color: "red" }}>*</span>
                  </label>
                  <Input
                    type="password"
                    id="password"
                    name="password"
                    onChange={handleChange}
                    value={values.password}
                    onBlur={handleBlur}
                    borderColor="gray"
                    borderWidth="1px"
                  />
                  <div style={{ color: "red" }}>
                    {errors.password && touched.password && errors.password}
                  </div>
                </div>

                <div>
                  <label htmlFor="confirmPassword">
                    Confirm Password <span style={{ color: "red" }}>*</span>
                  </label>
                  <Input
                    type="password"
                    id="confirmPassword"
                    name="confirmPassword"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.confirmPassword}
                    borderColor="gray"
                    borderWidth="1px"
                  />
                  <div style={{ color: "red" }}>
                    {errors.confirmPassword &&
                      touched.confirmPassword &&
                      errors.confirmPassword}
                  </div>
                </div>
                <Button
                  disabled={isSubmitting}
                  type="submit"
                  bg="#576CD1"
                  color="white"
                  _hover={{ bg: "#576CD1" }}
                  // onClick={nextStep}
                >
                  Next
                </Button>
              </form>
            )}
          </Formik>
        </CardBody>
      </Card>
    // </Box>
  );
};

export default LoginForm1;
